import React, { useEffect } from 'react';
import { Outlet, useOutlet, useNavigate, useLocation, useParams } from 'react-router-dom';

const HeadsUpRoot: React.FC = () => {
  const outlet = useOutlet();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (outlet) {
      return;
    }

    navigate('/heads-up/issues' + location.search, { replace: true });
  }, [outlet, navigate, location.search]);
  return <Outlet />;
};

export function HeadsUpIssueRedirect() {
  const { issueId } = useParams<{ issueId: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/heads-up/issues/${issueId}${location.search}`, { replace: true });
  }, [issueId, location.search, navigate]);

  return null;
}

export default HeadsUpRoot;
